// slices/categoryAnalyticsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCategoryVendorAnalytics } from "../services/api";

// Thunk to fetch category vendor analytics data
export const fetchCategoryAnalytics = createAsyncThunk(
  "categoryAnalytics/fetchCategoryAnalytics",
  async (timeline) => {
    const response = await fetchCategoryVendorAnalytics(timeline);
    return response;
  }
);

const categoryAnalyticsSlice = createSlice({
  name: "categoryAnalytics",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryAnalytics.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoryAnalytics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchCategoryAnalytics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default categoryAnalyticsSlice.reducer;
